import { FC } from 'react';

import CorporateHomePage from '@/pages/CorporateHomePage.tsx';
import HomePage from '@/pages/HomePage.tsx';
import { useAuthStore } from '@/stores/useAuthStore';

const HomeRoute: FC = () => {
  const role = useAuthStore((state) => state.role);

  if (role === 'admin') {
    return <HomePage />;
  }

  if (role === 'corporate') {
    return <CorporateHomePage />;
  }

  return null;
};

export default HomeRoute;
